import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import authComptableReducer from './authComptableSlice';
import authInfluenceurReducer from './authInfluenceurSlice'; // <-- ajouté

const store = configureStore({
  reducer: {
    auth: authReducer,
    authComptable: authComptableReducer,
    authInfluenceur: authInfluenceurReducer, // <-- ajouté
  },
});

export default store;
